/** Axios 쓰로틀 에러 여부 확인 */
export const isCanceledError = (error: any) => error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED';

/** API 에러 응답에서 code 추출 */
export const getApiErrorCode = (error: any): string | null => error?.response?.data?.error?.code ?? null;

/**
 * `_api` 레이어가 `res.success===false`일 때 던지는 에러. 이 타입일 때만 .message를 화면에 신뢰해서 보여준다 —
 * 그냥 `!isAxiosError`로만 구분하면 코드 버그로 우발적으로 던져진 TypeError 등의 영어 스택 메시지까지 사용자에게 노출될 수 있다.
 */
export class ApiBusinessError extends Error {}

/**
 * API 에러 응답에서 서버 메시지 추출.
 * axios 에러가 아니라 `ApiBusinessError`면 .message를 쓴다 — 그 Error엔 .response가 없어서 서버가 내려준 사유가 error.message에만 담겨 있다.
 * 빈 문자열도 "메시지 없음"으로 취급해야 호출부의 `apiMessage ?? retryMessage` 폴백이 제대로 동작하므로 ??가 아니라 ||로 걸러낸다.
 */
export const getApiErrorMessage = (error: any): string | null =>
  error?.response?.data?.error?.message || (error instanceof ApiBusinessError && error.message) || null;
